import React, { useMemo, useState, useEffect } from "react"
import PropTypes from "prop-types"
import TableContainer from "../../components/Common/TableContainer"
import Swal from "sweetalert2";
import { Link } from "react-router-dom"
import { deleteWebstory, getWebstories } from "service/api";

function DatatableTables() {

  const [webstories, setWebstories] = useState([]);

  useEffect(() => {
    getAllwebstories()
  }, []);

  const getAllwebstories = async () => {
    let res = await getWebstories();
    setWebstories(res.webstories);
  }


  const handleDelete = async (id) => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'Are you sure you want to delete this data?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await deleteWebstory(id);
          setWebstories(webstories.filter(site => site.id !== id));
          Swal.fire({
            icon: 'success',
            title: 'Success!',
            text: 'Webstories Delete successfully!',
          }).then(() => {
            getAllwebstories();
          });
        } catch (error) {
          console.error('Error deleting Webstories:', error);
          Swal.fire({
            icon: 'error',
            title: 'Error!',
            text: 'Failed to delete Webstories.',
          });
        }
      }
    }
    )
  };



  const columns = useMemo(
    () => [
      {
        Header: "Sr.no",
        accessor: "srNo",
        Cell: ({ row }) => row.index + 1,
      },
      {
        Header: "Title",
        accessor: "title",
      },
      {
        Header: "Date",
        accessor: "date",
      },
      {
        Header: "Actions",
        accessor: "id",
        Cell: ({ row }) => (
          <div style={{ display: "flex" }}>
            <button
              type="button"
              className="btn btn-danger  ml-2"
              onClick={() => handleDelete(row.original.id)}
            >
              <i className="mdi mdi-trash-can font-size-15"></i>
            </button>
          </div>
        ),
      },
    ],
    []
  )

  return (
    <div className="page-content">
      <div className="container-fluid">
        <div className="d-flex justify-content-between align-items-center mb-1"></div>
        {webstories && (
          <TableContainer
            columns={columns}
            data={webstories}
            isGlobalFilter={true}
            isAddOptions={false}
            customPageSize={10}
            className="custom-header-css"
          />
        )}
      </div>
    </div>
  )
}

DatatableTables.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
}

export default DatatableTables



